import React, { useState, useEffect } from 'react';
import Notification from '/Foundation/Common/code/Views/Foundation/Common/Notifications/Notification';
import Spinner from '/Foundation/Common/code/Views/Foundation/Common/Spinner';
import { br_setConsent } from '/Foundation/Bloomreach/code/Events/BloomreachConsent';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';

const PreferenceCenter = (preferenceCenterData) => {
  const [preferences, setPreferences] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasChange, setHasChange] = useState(false);
  const [savedPreferences, setSavedPreferences] = useState([]);
  const [saveSuccess, setSaveSuccess] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [approveDisclaimer, setApproveDisclaimer] = useState(false);

  const getCustomerConsent = () => {
    fetch(`/api/sitecore/bloomreach/customerconsents`, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          setSavedPreferences(data);
          setPreferences(data);
          setLoading(false);
        } else setHasError(true);
      })
      .catch((error) => console.log(error));
  };
  useEffect(() => {
    getCustomerConsent();
  }, []);

  useEffect(() => {
    const different = preferences.some((pref) => {
      const saved = savedPreferences.find((s) => s.Id === pref.Id);
      return !saved || saved.HasConsent !== pref.HasConsent;
    });
    setHasChange(different);
  }, [preferences]);

  const handleCheckboxChange = (bloomreachCategoryId) => {
    setPreferences((prev) =>
      prev.map((pref) =>
        pref.Id == bloomreachCategoryId
          ? { ...pref, HasConsent: pref.HasConsent == null ? true : !pref.HasConsent }
          : pref
      )
    );
  };

  const saveConsentForBloomreach = (preferences) => {
    if (!preferences?.length > 0) return;

    const filteredPreferences = preferences.filter((pref) => {
      const saved = savedPreferences.find((s) => s.Id === pref.Id);
      return !saved || saved.HasConsent !== pref.HasConsent;
    });

    let consentList = {};
    filteredPreferences.forEach((preference) => {
      consentList[preference.Id] = preference.HasConsent;
    });

    br_setConsent(_THULEDATA._preferenceCenter?.Email, consentList);
  };

  const handleSaveClick = () => {
    setHasError(false);
    saveConsentForBloomreach(preferences);
    setSavedPreferences(preferences);
    setHasChange(false);
    setSaveSuccess(true);
  };

  return (
    <div className="thule-container preference-center col-lg-6 m-auto mb-9 mt-9 p-lg-0">
      <h2 className="heading4 mb-4">{preferenceCenterData.Title}</h2>
      <div className="mb-8" dangerouslySetInnerHTML={{ __html: preferenceCenterData.Intro }} />
      {loading && (
        <div className="mb-4">
          <Spinner />
        </div>
      )}
      {!loading &&
        preferences.map((preference, index) => (
          <div key={index} className="mb-9">
            <h3 className="heading5 mb-4">{preference.Name}</h3>
            <p className="paragraph mb-6 text-color--gray80">{preference.Description}</p>
            <input
              type="checkbox"
              checked={preference.HasConsent}
              onChange={() => handleCheckboxChange(preference.Id)}
              id={preference.Name}
              className="me-4"
            />
            <label htmlFor={preference.Name} className="paragraph--s text-color--gray80">
              {preferenceCenterData.CheckboxYesText}
            </label>
          </div>
        ))}
      <button
        disabled={!hasChange || (!savedPreferences?.find((x) => x.HasConsent) && !approveDisclaimer)}
        className="mb-4 saveBtn btn thule-btn-default btn-md"
        onClick={handleSaveClick}
      >
        {preferenceCenterData.SaveButtonText}
      </button>
      {!savedPreferences?.find((x) => x.HasConsent) && (
        <div className="mb-4 d-flex align-items-center">
          <input
            type="checkbox"
            checked={approveDisclaimer}
            onChange={() => setApproveDisclaimer(!approveDisclaimer)}
            id={'newsletterDisclaimer'}
            className="me-4"
          />
          <label htmlFor={'newsletterDisclaimer'} className="paragraph--s text-color--gray80">
            <div dangerouslySetInnerHTML={{ __html: preferenceCenterData.NewsletterSignupDisclaimer }} />
          </label>
        </div>
      )}
      {hasError && (
        <Notification
          ShowIcon={true}
          IsToast={true}
          Type={'error'}
          Size={'lg'}
          Message={preferenceCenterData.ErrorText}
        />
      )}
      {saveSuccess && (
        <Notification
          IsToast={true}
          ShowIcon={true}
          Type={'success'}
          Size={'lg'}
          CloseAction={() => {
            setSaveSuccess(false);
          }}
          Message={preferenceCenterData.SettingsSavedText}
        />
      )}
    </div>
  );
};

export default PreferenceCenter;

const root = createRoot(document.getElementById('REACT_preferenceCenter'));
const prefCenterModel = window._THULEDATA._preferenceCenter || {};
root.render(
  <Sentry.ErrorBoundary>
    <PreferenceCenter {...prefCenterModel} />
  </Sentry.ErrorBoundary>
);
